const DecayReducer = (state = {}, action) => {
    switch (action.type) {
        case 'SET_DECAY':
            return action.payload;
        default:
            return state;
    }
}

export default DecayReducer;